export function ShowMessage(props) {
  return (
    <>
      {props.status === 200 ? (
        <div className="alert alert-success" role="alert">
          {props.message}
        </div>
      ) : (
        ""
      )}

      {props.status === 401 ? (
        <div className="alert alert-danger" role="alert">
          {props.message}
        </div>
      ) : (
        ""
      )}

      {props.status === 402 ? (
        <div className="alert alert-danger" role="alert">
          {props.message}
        </div>
      ) : (
        ""
      )}

      {props.status === 422 ? (
        <div className="alert alert-danger" role="alert">
          {props.message}
        </div>
      ) : (
        ""
      )}

      {props.status === 500 ? (
        <div className="alert alert-danger" role="alert">
          {props.message}
        </div>
      ) : (
        ""
      )}
    </>
  );
}
